export var getAllPersonNodesSchemaObject = {
    $schema: 'http://json-schema.org/schema#',
    type: 'object',
    additionalProperties: true,
    properties: {
        totalPages: {
            type: 'integer',
        },
        totalElements: {
            type: 'integer',
        },
        size: {
            type: 'integer',
        },
        content: {
            type: 'array',
            items: {
                type: 'string',
            },
        },
        number: {
            type: 'integer',
        },
        sort: {
            type: 'object',
            additionalProperties: true,
            properties: {
                sorted: {
                    type: 'boolean',
                },
                unsorted: {
                    type: 'boolean',
                },
                empty: {
                    type: 'boolean',
                },
            },
        },
        numberOfElements: {
            type: 'integer',
        },
        first: {
            type: 'boolean',
        },
        last: {
            type: 'boolean',
        },
        pageable: {
            type: 'object',
            additionalProperties: true,
            properties: {
                offset: {
                    type: 'integer',
                },
                pageNumber: {
                    type: 'integer',
                },
                pageSize: {
                    type: 'integer',
                },
                paged: {
                    type: 'boolean',
                },
                sort: {
                    type: 'object',
                    additionalProperties: true,
                    properties: {
                        sorted: {
                            type: 'boolean',
                        },
                        unsorted: {
                            type: 'boolean',
                        },
                        empty: {
                            type: 'boolean',
                        },
                    },
                },
                unpaged: {
                    type: 'boolean',
                },
            },
        },
        empty: {
            type: 'boolean',
        },
    },
};
export var getNodeSchemaObject = {
    $schema: 'http://json-schema.org/schema#',
    type: 'object',
    additionalProperties: true,
    properties: {
        parent: {
            type: 'string',
        },
        type: {
            type: 'string',
        },
        accountName: {
            type: 'string',
        },
        description: {
            type: 'string',
        },
        tags: {
            type: 'array',
            items: {
                type: 'string',
            },
        },
        nodeId: {
            type: 'string',
        },
        fully_qualified_id: {
            type: 'string',
        },
        dateCreated: {
            type: 'integer',
        },
    },
};
//# sourceMappingURL=relationships.schemas.js.map